// Service disciplines — used by Services list, Service detail pages, Footer.
// Each entry contains SEO-friendly bilingual copy for long-tail discoverability.

export const SERVICES_LIST = [
  {
    slug: "logo-branding",
    name: "Logo + Branding",
    accent: "#5b4bff",
    tagline: {
      en: "Brand identity that earns trust at every touchpoint.",
      id: "Identitas merek yang membangun kepercayaan di setiap titik sentuh.",
    },
    intro: {
      en: "A logo is the smallest part of branding. We design identity systems — typography, voice, motion, and rules — that hold up across every surface your customers meet.",
      id: "Logo hanyalah bagian terkecil dari branding. Kami merancang sistem identitas — tipografi, nada bicara, gerak, dan aturan — yang konsisten di setiap permukaan yang ditemui pelanggan Anda.",
    },
    deliverables: {
      en: ["Brand strategy & positioning", "Logo system & wordmark", "Typography & colour system", "Voice & tone guidelines", "Brand book PDF + Figma library", "Launch assets for digital & print"],
      id: ["Strategi & positioning merek", "Sistem logo & wordmark", "Sistem tipografi & warna", "Pedoman nada bicara", "Brand book PDF + Figma library", "Aset peluncuran digital & cetak"],
    },
    process: {
      en: ["Discovery: stakeholder interviews & audit", "Direction: 3 distinct concept territories", "Refinement: 2 rounds of revision", "System: full identity build-out", "Handover: brand book & training"],
      id: ["Discovery: wawancara stakeholder & audit", "Arah: 3 teritori konsep berbeda", "Penyempurnaan: 2 putaran revisi", "Sistem: pembangunan identitas penuh", "Serah terima: brand book & pelatihan"],
    },
  },
  {
    slug: "ui-ux-research",
    name: "UI/UX Research",
    accent: "#5b4bff",
    tagline: {
      en: "Research that turns behaviour into product decisions.",
      id: "Riset yang mengubah perilaku menjadi keputusan produk.",
    },
    intro: {
      en: "We run research programmes that produce decisions, not slide decks. Mixed-method studies tailored to the Indonesian context — fast enough for sprint teams, rigorous enough for product strategy.",
      id: "Kami menjalankan program riset yang menghasilkan keputusan, bukan deck presentasi. Studi multi-metode yang disesuaikan untuk konteks Indonesia — cukup cepat untuk tim sprint, cukup ketat untuk strategi produk.",
    },
    deliverables: {
      en: ["Discovery interviews (8–12 sessions)", "Ethnographic field studies", "Usability testing (moderated & unmoderated)", "Quantitative survey & analytics review", "Personas, journeys & opportunity maps", "Prioritised research-to-decision report"],
      id: ["Wawancara discovery (8–12 sesi)", "Studi lapangan etnografi", "Uji usability (terpandu & tidak terpandu)", "Survei kuantitatif & review analitik", "Persona, perjalanan & peta peluang", "Laporan riset-ke-keputusan terprioritisasi"],
    },
    process: {
      en: ["Frame: research questions & success criteria", "Recruit: representative Indonesian users", "Field: sessions in-person and remote", "Synthesis: cross-functional workshop", "Decision: prioritised recommendations"],
      id: ["Bingkai: pertanyaan riset & kriteria sukses", "Rekrut: pengguna Indonesia representatif", "Lapangan: sesi tatap muka dan jarak jauh", "Sintesis: workshop lintas fungsi", "Keputusan: rekomendasi terprioritisasi"],
    },
  },
  {
    slug: "web-app-development",
    name: "Web + App Development",
    accent: "#5b4bff",
    tagline: {
      en: "Modern software engineering, accountable to scale.",
      id: "Rekayasa perangkat lunak modern yang dapat dipertanggungjawabkan dalam skala.",
    },
    intro: {
      en: "Production-grade web and mobile applications with the disciplines that matter when traffic grows: testing, observability, CI/CD, and an engineering team you can audit.",
      id: "Aplikasi web dan mobile berkualitas produksi dengan disiplin yang penting saat trafik bertumbuh: testing, observability, CI/CD, dan tim engineering yang dapat Anda audit.",
    },
    deliverables: {
      en: ["Frontend (React, Next.js, React Native)", "Backend (Node, FastAPI, Postgres)", "Cloud architecture (AWS, GCP)", "CI/CD & observability stack", "Test suites & code review process", "Operational runbooks"],
      id: ["Frontend (React, Next.js, React Native)", "Backend (Node, FastAPI, Postgres)", "Arsitektur cloud (AWS, GCP)", "Stack CI/CD & observability", "Test suite & proses code review", "Runbook operasional"],
    },
    process: {
      en: ["Architecture: scope & tech choices", "Sprint zero: env, CI, design system", "Build: 2-week iterative sprints", "Hardening: load tests & security review", "Launch & operate: dashboards, on-call"],
      id: ["Arsitektur: ruang lingkup & pilihan teknologi", "Sprint zero: env, CI, design system", "Bangun: sprint iteratif 2 minggu", "Hardening: load test & review keamanan", "Luncurkan & operasikan: dashboard, on-call"],
    },
  },
  {
    slug: "customer-experience",
    name: "Customer Experience",
    accent: "#8174ff",
    tagline: {
      en: "Consistent journeys from first visit to long retention.",
      id: "Perjalanan konsisten dari kunjungan pertama hingga retensi panjang.",
    },
    intro: {
      en: "CX is not just a CRM project. We design the end-to-end experience — service blueprint, communications, channels, and tooling — so customers feel the same brand promise everywhere.",
      id: "CX bukan sekadar proyek CRM. Kami merancang pengalaman ujung-ke-ujung — service blueprint, komunikasi, kanal, dan tooling — sehingga pelanggan merasakan janji merek yang sama di mana saja.",
    },
    deliverables: {
      en: ["Service blueprint mapping", "Customer data platform integration", "Omnichannel communications playbook", "Lifecycle automation (email, WhatsApp)", "CX metrics & NPS programme", "Team enablement & training"],
      id: ["Pemetaan service blueprint", "Integrasi customer data platform", "Playbook komunikasi omnichannel", "Otomasi lifecycle (email, WhatsApp)", "Metrik CX & program NPS", "Enablement & pelatihan tim"],
    },
    process: {
      en: ["Map: current journey & moments of truth", "Define: target experience principles", "Wire: tooling, data, automations", "Pilot: contained launch & measure", "Scale: roll out to full org"],
      id: ["Pemetaan: perjalanan saat ini & moment of truth", "Definisi: prinsip pengalaman target", "Wiring: tooling, data, otomasi", "Pilot: peluncuran terbatas & ukur", "Skala: rollout ke seluruh organisasi"],
    },
  },
];
